'use client'

import {useSession} from "next-auth/react";
import {GlobalRole} from "@/app/auth/roles";

export interface UserRoles {
  admin: boolean;
  canCreateCompany: boolean;
  loaded: boolean;
}

export function useUserRoles(): UserRoles {
  const session = useSession()
  const roles = session?.data?.user?.globalRoles ?? []
  const loaded = session && session?.data?.user?.globalRoles !== undefined
  const admin = roles.includes(GlobalRole.ADMIN);
  const canCreateCompany = admin || roles.includes(GlobalRole.CUSTOMER)
  return {admin, canCreateCompany, loaded}
}